module.exports = __webpack_public_path__ + "img/logo.05eadbd7.png";